import dayjs from 'dayjs';

const whatsNewList = [
  { date: "11-07-2025", items: [
    "When scheduling a scan, you can now check a box to mark that you are scheduling multiple scans in the same household to receive a discount.",
    "When scheduling a scan, the system will provide available scan dates that are 10 days out from today, rather than 14, making it more realistic for the next scan date.",
    "Removed address from the client form that they submit prior to a scan as it was unnecessary."
  ]},
  { date: "11-08-2025", items: [
    "Added What's New to the Dashboard for app updates.",
    "Added Cost Structure to Resource list, providing detail of how much servies and items cost."
  ]},
  { date: "11-17-2025", items: [
    "Updated Cost & Payment Process page of Training.",
    "Updated Cost Structure in Resource List to reflect simple pricing and to encourage follow-up visits."
  ]},
  { date: "12-06-2025", items: [
    "Updated Cost Structure with Practitioner Family costs.",
    "Updated Cost & Payment Process of Training to include Practitioner Family costs.",
    "Added a checkbox on client records so Practitioners can mark a client as a member of their family to receive a discount on scans."
  ]},
  { date: "12-12-2025", items: [
    "Clients will receive an email with tracking information and a link to complete their client form once a Kit has been mailed. As well as an email for when their Imprint Remedy is mailed.",
  ]},
  { date: "12-15-2025", items: [
    "If the client scan requires a second imprint, we have added the ability for our team to charge the practitioner the $20 for the additional imprint remedy. The practitioner will be notified of this via email.",
    "We added a 'Total Paid' section to all new scans moving forward that will show the amount paid for that scan. Eventually we will show the itemized list of charges, and the ability to pull up an itemized receipt.",
    "If a scan gets Cancelled, an email is now sent to the practitioner confirming that the scan has been cancelled."
  ]},
  { date: "12-17-2025", items: [
    "Itemized list of transactions added to Total Paid section of Scans, with ability to view an itemized receipt.",
    "Added Wellness Scan and Diet Guide as options to be uploaded to the shareable Client Reports section of each scan."
  ]},
  { date: "12-23-2025", items: [
    "Inbox for sending generic messages and questions between yourself and the TruBalance Team has been added."
  ]},
  { date: "01-12-2026", items: [
    "Call Schedule removed as we were not utilizing it.",
    "Added the ability to request a 1:1 Support Call (under Resources). Fill out this form with your availability and we will work within our schedules to find a time to connect.",
    "Add Imprint Remedy drops/weeks data to the Reports section of Scans."
  ]},
];

const sortedWhatsNewList = [...whatsNewList].sort((a, b) => 
  dayjs(b.date, "MM-DD-YYYY").valueOf() - dayjs(a.date, "MM-DD-YYYY").valueOf()
);

export function getNewItem() {
  return sortedWhatsNewList[0];
}

// Export the whatsNewList
export { sortedWhatsNewList as whatsNewList };